// extracted by mini-css-extract-plugin
module.exports = {"allResorts":"styles_allResorts__wGw0H","resortsList":"styles_resortsList__PAHm4","btnViewAllResorts":"styles_btnViewAllResorts__aUQ3C"};